import { render, staticRenderFns } from "./OverviewOtherPurchases.vue?vue&type=template&id=59386c56&scoped=true"
import script from "./OverviewOtherPurchases.vue?vue&type=script&lang=js"
export * from "./OverviewOtherPurchases.vue?vue&type=script&lang=js"
import style0 from "./OverviewOtherPurchases.vue?vue&type=style&index=0&id=59386c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59386c56",
  null
  
)

export default component.exports